import { useEffect, useRef, useState } from 'react';

const SEARCH_DEBOUNCE_MS = 300;

// The box's live text, committed after a pause; it follows the committed value only when that
// changes elsewhere (Clear filters, a nav link), never in answer to its own commit.
export function useSearchInput(committed: string, commit: (value: string) => void) {
    const [input, setInput] = useState(committed);
    const ownCommit = useRef(committed);

    useEffect(() => {
        if (committed === ownCommit.current) return;
        ownCommit.current = committed;
        setInput(committed);
    }, [committed]);

    useEffect(() => {
        const trimmed = input.trim();
        if (trimmed === committed) return;
        const handle = setTimeout(() => {
            ownCommit.current = trimmed;
            commit(trimmed);
        }, SEARCH_DEBOUNCE_MS);
        return () => clearTimeout(handle);
    }, [input, committed, commit]);

    return [input, setInput] as const;
}
